import { action, makeObservable, observable } from 'mobx';

import URLS from 'jsx/constants/urls';
import { get } from 'jsx/utils/axiosWrapper';
import { useEffectOnce } from 'jsx/utils/hooks/useEffectOnce';
import useStores from 'jsx/utils/hooks/useStores';

interface Promotion {
  id: number;
  code: string;
  isActive: boolean;
  startsAt: string;
  endsAt: string;
  amountInDollars: number;
}

export default class PromotionStore {
  @observable
  promotion?: Promotion;

  constructor() {
    makeObservable(this);
  }

  @action
  fetchPromotion = (code: string, silent = true) =>
    get<{ promotion?: Promotion }>(URLS.api.promotions({ code }), {
      validateStatus: silent ? () => true : undefined,
    }).then(({ data }) => {
      this.promotion = data.promotion;
    });
}

export const usePromotionStore = () => {
  const { promotionStore } = useStores<PromotionStore>();

  return { promotionStore };
};

export const usePromotion = (code: string) => {
  const {
    promotionStore: { promotion, fetchPromotion },
  } = usePromotionStore();

  useEffectOnce(() => {
    if (!promotion && code) {
      fetchPromotion(code);
    }
  });

  return promotion;
};
